module.exports = __webpack_public_path__ + "assets/caf02be12af45774b5f5e9d1829eead8.jpg";